module.exports = __webpack_public_path__ + "img/step37_a_connect_side_blockers.7fed88d6.png";